// --- Flits store-credit hand-off (added 2026-11-04) ----------------------------------------
// This script intercepts every checkout click, so Flits' own checkout-button handler never
// gets to apply the customer's selected points. Every redirect to checkout therefore goes
// through goToCheckout(), which asks Flits for the credit discount code first (Flits ticket
// #550487). "+" is Flits' documented placeholder when no credit is selected.
const HULK_FORM_ORIGIN = 'https://formbuilder.hulkapps.com';
let hulkCheckoutRedirecting = false;

function hulkCustomerIsLoggedIn() {
  const placeholder = document.querySelector('.hulk-form-placeholder[data-customer-email]');
  if (placeholder && placeholder.dataset.customerEmail) return true;
  const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
  return Boolean(meta && meta.page && meta.page.customerId);
}

async function hulkFlitsDiscountCode() {
  if (!hulkCustomerIsLoggedIn() || typeof window.flitsApplyCredit !== 'function') return '+';
  try {
    // Never strand the customer on the cart if Flits hangs.
    const timeout = new Promise((resolve) => window.setTimeout(() => resolve(null), 8000));
    const result = await Promise.race([window.flitsApplyCredit(), timeout]);
    if (result && result.success && result.code) return encodeURIComponent(result.code);
  } catch (error) {
    // Fall through to the no-credit checkout.
  }
  return '+';
}

// Code already fetched for the Rx path (see hulkPreApplyFlitsToCart), so the form's
// post-submit hand-off doesn't ask Flits for a second code.
let hulkPreparedDiscount = null;

// Rx carts: the Hulk form redirects the whole page to /checkout from inside its iframe on
// submit, so our redirect never runs. Attach the Flits code to the CART before opening the
// form — a cart-level code carries into checkout whichever script performs the redirect.
async function hulkPreApplyFlitsToCart() {
  const discount = await hulkFlitsDiscountCode();
  hulkPreparedDiscount = discount;
  if (discount === '+') return;
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: decodeURIComponent(discount) }),
    });
  } catch (error) {
    // Non-fatal: goToCheckout() still passes the code in the URL if our redirect runs.
  }
}

async function goToCheckout() {
  if (hulkCheckoutRedirecting) return;
  hulkCheckoutRedirecting = true;
  const discount = hulkPreparedDiscount || (await hulkFlitsDiscountCode());
  window.location.href = '/checkout?discount=' + discount;
}
// -------------------------------------------------------------------------------------------

function hulkappsModalFormInit() {
  let isFormSubmit = false;
  const modal = document.querySelector('.hulk-modal');
  const exitModal = document.querySelector('.hulk-modal span.close');

  if (!modal || !exitModal) return;

  const formIds = {
    'rx-obagi-hydroquinone': 'eIHRi1E31rjr28ZzmMM58Q',
    'rx-obagi-tretinoin': 'PLBERkOGy3o6ROwFLd9vmA',
    'rx-upneeq': 'SbAUGc0CiyCcRJYGTzxe6A',
    'rx-latisse': 'ygw0zksI1_WwHGVdLNlIUw',
  };

  function showModal() {
    modal.style.display = 'flex';
    document.documentElement.classList.add('prevent_scroll');
  }

  function hideModal() {
    modal.style.display = 'none';
    document.documentElement.classList.remove('prevent_scroll');
  }

  function createFormIframe(form) {
    let iframe = form.querySelector('iframe');
    if (iframe) return iframe;

    const formUrl = new URL('https://formbuilder.hulkapps.com/corepage/customform');
    formUrl.searchParams.set('id', form.id);
    formUrl.searchParams.set('referrer_url', window.location.href);
    if (form.dataset.customerEmail) {
      formUrl.searchParams.set('customer_email', form.dataset.customerEmail);
    }

    iframe = document.createElement('iframe');
    iframe.src = formUrl.toString();
    iframe.id = `frame_${form.id}`;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('title', form.dataset.formTitle || 'Prescription approval form');
    form.appendChild(iframe);
    return iframe;
  }

  function showForm(formId) {
    const formToShow = document.getElementById(formId);
    if (!formToShow) return null;

    document.querySelectorAll('.hulk-form-placeholder').forEach((form) => {
      form.style.display = 'none';
    });

    const iframe = createFormIframe(formToShow);
    formToShow.style.display = 'block';
    return iframe;
  }

  function sendProductsToForm(iframe, products) {
    let attempts = 0;
    const hook = window.setInterval(() => {
      attempts += 1;
      if (iframe.contentWindow) {
        iframe.contentWindow.postMessage({ products }, HULK_FORM_ORIGIN);
      }
      if (attempts >= 40) window.clearInterval(hook);
    }, 500);

    const confirmReceipt = (event) => {
      if (event.origin === HULK_FORM_ORIGIN && event.data && event.data.received) {
        window.clearInterval(hook);
        window.removeEventListener('message', confirmReceipt);
      }
    };
    window.addEventListener('message', confirmReceipt);
  }

  exitModal.addEventListener('click', hideModal);
  document.addEventListener('click', (event) => {
    if (event.target === modal) hideModal();
  });

  document.body.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!checkoutButton || isFormSubmit) return;

    event.preventDefault();
    checkCart();
  }, true);

  // --- Rx safety net (added 2026-08-17) -------------------------------------------------
  // The product form stamps Rx items with properties[_approval_needed] (see
  // snippets/collection-product__form.liquid). Items added by other paths — upsell
  // pop-ups, "Buy again", quick-adds via /cart/add.js — arrive WITHOUT that property.
  // For any item lacking it we look up the product's tags and, if it is an Rx product,
  // (a) repair the property on the cart line so the order is still flagged for staff, and
  // (b) gate checkout behind the approval form exactly as before.
  const rxTagCache = {};

  async function lookupRxTag(handle) {
    if (!handle) return null;
    if (Object.prototype.hasOwnProperty.call(rxTagCache, handle)) return rxTagCache[handle];
    let found = null;
    try {
      const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
      });
      if (response.ok) {
        const product = await response.json();
        const tags = Array.isArray(product.tags)
          ? product.tags
          : String(product.tags || '').split(',').map((tag) => tag.trim());
        found = tags.find((tag) => formIds[tag]) || null;
      }
    } catch (error) {
      found = null;
    }
    rxTagCache[handle] = found;
    return found;
  }

  async function repairApprovalProperty(item, tag) {
    try {
      const properties = Object.assign({}, item.properties || {}, { _approval_needed: tag });
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: item.quantity, properties }),
      });
    } catch (error) {
      // Non-fatal: the checkout is still gated below even if the repair failed.
    }
  }

  async function resolveApprovalTags(cart) {
    const approvalTags = [];
    for (const item of cart.items) {
      let tag = item.properties && item.properties._approval_needed;
      if (!(tag && formIds[tag])) {
        tag = await lookupRxTag(item.handle);
        if (tag) await repairApprovalProperty(item, tag);
      }
      if (tag && formIds[tag]) approvalTags.push(tag);
    }
    return approvalTags;
  }
  // -------------------------------------------------------------------------------------

  async function checkCart() {
    let approvalTags = [];
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
      approvalTags = await resolveApprovalTags(cart);
    } catch (error) {
      approvalTags = [];
    }

    if (approvalTags.length === 0) {
      isFormSubmit = true;
      hideModal();
      await goToCheckout();
      return;
    }

    await hulkPreApplyFlitsToCart();

    const activeIframe = showForm(formIds[approvalTags[approvalTags.length - 1]]);
    if (!activeIframe) return;

    sendProductsToForm(activeIframe, approvalTags);
    showModal();
  }
}

document.addEventListener('DOMContentLoaded', hulkappsModalFormInit);

// The Hulk form iframe posts 'close_modal' after a submission; only trust it from Hulk's origin.
window.addEventListener('message', async (event) => {
  if (event.origin !== HULK_FORM_ORIGIN || event.data !== 'close_modal') return;

  const modal = document.querySelector('.hulk-modal');
  if (modal) {
    modal.style.display = 'none';
    document.documentElement.classList.remove('prevent_scroll');
  }
  await goToCheckout();
});
